export default __webpack_public_path__ + "static/media/banner-170x340-bg-darkblue-template.337be109.svg";